import { useEffect, useMemo, useState } from "react";
import { withNamespaces } from "react-i18next";
import TableFilter from "src/components/TableFilter";
import { HiChevronDoubleDown, HiChevronDoubleUp, HiMenuAlt4 } from 'react-icons/hi';

const FilteringComponent = ({
    t,
    onChange
}) => {
    const [ tableFilters, setTableFilters ] = useState({
        status: null,
        priority: null
    });

    const priorities = useMemo(() => {
        return [
            {
                value: "low",
                baseLabel: "Low",
                label: (
                    <>
                        <HiChevronDoubleDown className="text-info" />
                        <span>{t("Low")}</span>
                    </>
                ),
            },
            {
                value: "medium",
                baseLabel: "Medium",
                label: (
                    <>
                        <HiMenuAlt4 className="text-success" />
                        <span>{t("Medium")}</span>
                    </>
                ),
            },
            {
                value: "high",
                baseLabel: "High",
                label: (
                    <>
                        <HiChevronDoubleUp className="text-danger" />
                        <span>{t("High")}</span>
                    </>
                ),
            },
        ];
    }, [t]);

    const statuses = useMemo(() => {
        return [
            { value: "NEW", label: t("New") },
            { value: "IN_PROGRESS", label: t("In Progress") },
            { value: "REVIEW", label: t("Review") },
            { value: "CLOSED", label: t("Closed") },
            { value: "DELETED", label: t("Deleted") },
        ];
    }, [t]);

    const tableFilterTabs = useMemo(() => {
        return [
            {
                type: 'radio_list',
                name: 'status',
                title: 'Task Status',
                icon: <i className="ri-checkbox-circle-line" />,
                isLoading: false,
                defaultValue: tableFilters?.status,
                data: (statuses || []).map((item) => ({
                    ...item,
                    id: item.value
                })),
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return t(item.label) 
                }
            },
            {
                type: 'radio_list',
                name: 'priority',
                title: 'Priority',
                icon: <i className="ri-arrow-up-down-fill" />,
                isLoading: false,
                defaultValue: tableFilters?.priority,
                data: (priorities || []).map((item) => ({
                    ...item,
                    id: item.value
                })),
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return t(item.baseLabel) 
                }
            }
        ]
    }, [
        tableFilters,
        priorities,
        statuses,
        t
    ]);

    const onTableFilterOkButtonClicked = (filters) => {
        if (filters) {
            const result = {}
            if ('status' in filters) {
                result.status = filters.status !== 'all' ? filters.status : undefined
            }

            if ('priority' in filters) {
                result.priority = filters.priority !== 'all' ? filters.priority : undefined
            }

            setTableFilters({
                ...tableFilters,
                ...result
            })
        } else {
            setTableFilters({
                status: null,
                priority: null
            })
        }
    }

    useEffect(() => {
        onChange && onChange(tableFilters)
    }, [ 
        tableFilters,
        onChange
    ]);

    return (
        <TableFilter
            className="me-2"
            defaultActiveTab='status'
            tabs={tableFilterTabs}
            onOkButtonClicked={
                onTableFilterOkButtonClicked
            }
        />
    )
}

export default withNamespaces()(FilteringComponent);